import setItem from './setItem';

export default setItem;
